import { IntlFormatters } from "react-intl";
import defineMessages from "../defineMessages";

const eraMessages = defineMessages({
    middle: {
        id: "meta.era.middle",
    },
    renaissance: {
        id: "meta.era.renaissance",
    },
    baroque: {
        id: "meta.era.baroque",
    },
    classical: {
        id: "meta.era.classical",
    },
    romantique: {
        id: "meta.era.romantique",
    },
    "20turn": {
        id: "meta.era.20turn",
    },
    "20century": {
        id: "meta.era.20century",
    },
    modern: {
        id: "meta.era.modern",
    },
});

export const eras = (fm: IntlFormatters["formatMessage"]) => {
    return [
        { value: "middle", label: fm(eraMessages["middle"]) },
        { value: "renaissance", label: fm(eraMessages["renaissance"]) },
        { value: "baroque", label: fm(eraMessages["baroque"]) },
        { value: "classical", label: fm(eraMessages["classical"]) },
        { value: "romantique", label: fm(eraMessages["romantique"]) },
        { value: "20turn", label: fm(eraMessages["20turn"]) },
        { value: "20century", label: fm(eraMessages["20century"]) },
        { value: "modern", label: fm(eraMessages["modern"]) },
    ];
};